module.exports = __webpack_public_path__ + "img/UI_SSL_yuanbao_05_9712f2183.png";